module.exports = __webpack_public_path__ + "static/img/dian-icon-end.8a5ed577.png";